import { AxnCompany, AxnRelyingParty, FormattedAxnRelyingParty } from "@idw-types/data/reference-data/axn";

export const formatRelyingParties = (
    relyingParties: Array<AxnRelyingParty>,
    companies: Array<AxnCompany>
): Array<FormattedAxnRelyingParty> => {
    return relyingParties.map(rp => formatRelyingParty(rp, companies));
};

export const formatRelyingParty = (
    relyingParty: AxnRelyingParty,
    companies: Array<AxnCompany>
): FormattedAxnRelyingParty => {
    const company = companies.find(c => c.id === relyingParty.companyID);
    return {
        company: company,
        contractCode: relyingParty.contractCode,
        customAXNHostName: relyingParty.customAXNHostName,
        customDCUIHostName: relyingParty.customDCUIHostName,
        id: relyingParty.id,
        name: relyingParty.name,
        whiteLabelAXNUI3HostName: relyingParty.whiteLabelAXNUI3HostName,
        whiteLabelAXNUIHostName: relyingParty.whiteLabelAXNUIHostName,
        whiteLabelDCUIHostName: relyingParty.whiteLabelDCUIHostName,
        whiteLabelKBAHostName: relyingParty.whiteLabelKBAHostName,
        whiteLabelKBA2HostName: relyingParty.whiteLabelKBA2HostName,
        permissions: relyingParty.permissions,
        status: relyingParty.status
    };
};